import React from "react"
import type { PropsWithChildren } from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import Drawer, {
    DrawerPlacement,
    DrawerSize,
} from "~components/shared/todo-lib-react-components/drawer"

interface Props extends PropsWithChildren {
    readonly isOpen?: boolean
    readonly onClose: () => void
    readonly shouldRenderFullHeight?: boolean
    readonly shouldHaveHorizontalPadding?: boolean
    readonly shouldHaveExtraBottomPadding?: boolean
}

export default function BottomDrawer({
    isOpen,
    onClose,
    shouldRenderFullHeight,
    shouldHaveHorizontalPadding,
    shouldHaveExtraBottomPadding,
    children,
}: Props) {
    const styles = useStyles({
        shouldHaveHorizontalPadding,
        shouldHaveExtraBottomPadding,
    })

    const drawerSize = shouldRenderFullHeight
        ? DrawerSize.Full
        : DrawerSize.ExtraLarge

    return (
        <Drawer
            style={styles.root}
            isOpen={isOpen}
            onClose={onClose}
            size={drawerSize}
            placement={DrawerPlacement.Bottom}
        >
            {children}
        </Drawer>
    )
}

function useStyles({
    shouldHaveHorizontalPadding,
    shouldHaveExtraBottomPadding,
}: {
    shouldHaveHorizontalPadding?: boolean
    shouldHaveExtraBottomPadding?: boolean
}) {
    return componentStyles({
        root: {
            marginX: shouldHaveHorizontalPadding ? 4 : 0,
            marginTop: 8,
            marginBottom: shouldHaveExtraBottomPadding ? 12 : 4,
        },
    })
}
